// extracted by mini-css-extract-plugin
export var completionBody = "_d0-2";
export var completionCard = "_d0-0";
export var completionFooter = "_d0-3";
export var completionTitle = "_d0-1";